module.exports = __webpack_public_path__ + "img/home-btn-ji.5737fb66.png";